export const SET_CALIFORNIA_TOAST_FLAG = 'SET_CALIFORNIA_TOAST_FLAG'
export const SET_CALIFORNIA_TOAST_CLOSED = 'SET_CALIFORNIA_TOAST_CLOSED' 